import React, { Component } from 'react';
import './Login.css';
import stck from '../../images/public/login/stck.png';
import logo from '../../images/public/login/logo.png';
import mail from '../../images/public/login/mail.png';
import lock from '../../images/public/login/lock.png';
//import wstu from '../../images/public/login/wstu.png';
//import eyen from '../../images/public/login/eyen.png';
//import eyec from '../../images/public/login/eyec.png';
//import { BrowserView, MobileView, isBrowser, isMobile, isTablet, isMobileOnly, isAndroid, isFirefox, isSafari, browserName } from 'react-device-detect';
import { BrowserView, MobileView, isFirefox} from 'react-device-detect';
//import { RadioGroup, Radio } from 'react-radio-group';
//import { height } from 'window-size';
//import WebFont from 'webfontloader';
import { userFetch, userLoginFetch, isLogged, userRegForSocialLogin, isPhoneNumberVerified } from '../../libs/fetch';
import tr from '../../libs/tr'
import AlertPnl from "../../assets/components/panel/AlertPnl";
import { Config, firebaseConfig, firebaseConfig_test } from '../../Config';
import Cookies from 'universal-cookie';
import { BrowserRouter as Router, Route, Link, Redirect } from "react-router-dom";
//import Inseriscidati from '../Inseriscidati/Inseriscidati';
import FacebookLogin from 'react-facebook-login';
import * as firebase from "firebase/app";
import "firebase/auth";
import FirebaseLogger from '../../libs/FirebaseLogger';
import DownloadAppButton from '../../components/DownloadAppButton';
// import "firebase/analytics";

const cookies = new Cookies();

//init user
let user;

class Login extends Component {

	constructor(props) {
		document.body.classList.remove('alt_bg');
		
		super(props);
			//console.log("Login: ");
			try {
				firebase.initializeApp(Config.test=="0"? firebaseConfig: firebaseConfig_test);
			} catch (error) {
				console.warn("firebase.initializeApp", error);
			}
		// Initialize Firebase Analytics
		try {
			firebase.analytics();
		} catch (error) {
			// Already initialized
		}

		// set component state
		this.state = {
			redirect: false,
			route: '',
			user: null,
			username: '',
			password: '',
			password1: '',
			isLoading: true,
			email: '',
			warning: false,
			warningMessage: tr.t("Oops"),
			usrnameErr: false,
			passErr: false,
			passFlag: "password",

			loginEnable: false, //enables login button

		};

		// bind handlers
		this.handleChangeUsername = this.handleChangeUsername.bind(this);
		this.handleChangePassword = this.handleChangePassword.bind(this);
		// this.handleAppleResponse = this.handleAppleResponse.bind(this);
		this.userLogin = this.userLogin.bind(this);
		this.googleLogin = this.googleLogin.bind(this);


	}



	gotoUserArea = () => {
		// //check if user has any missing information
		// let user = JSON.parse(localStorage.getItem('user'));
		// console.log('[Login] @user:', user);
		// const { email, data_nasc, tel_cell } = user;
		// console.log('[Login] @user:', !!email , !!data_nasc , !!tel_cell);
		// if (!!email && !!data_nasc && !!tel_cell) {
		//   return this.props.history.push('/userarea');
		// } else {
		//   return this.props.history.push('/signup');
		// }

		let user;
		let access_token = cookies.get('access_token');

		userFetch(this, { access_token: access_token })
			.then((response) => {
				//console.log(response);
				if (response) {
					user = response;
					this.setState({ user: user });
					localStorage.setItem('user', JSON.stringify(response));
					const { email, data_nasc, tel_cell } = user;
					//console.log('[Login] @user:', !!email, !!data_nasc, !!tel_cell);
					
					// Check if user has basic required information
					if (!email || !data_nasc || !tel_cell) {
						//console.log('[Login] @user: after2', !email, !data_nasc, !tel_cell);
						return this.props.history.push('/signup');
					}
					
					// Check if phone number is verified using API
					isPhoneNumberVerified(this).then((phoneResponse) => {
						if (phoneResponse && phoneResponse.status === 'success') {
							if (phoneResponse.verified === 0) {
								// Phone not verified, redirect to verification page
								localStorage.setItem('backto', 'userarea');
								return this.props.history.push('/confirm-phone');
							}
							// Phone verified, proceed to user area
							return this.props.history.push('/userarea');
						} else {
							// If check fails, assume not verified for security
							localStorage.setItem('backto', 'userarea');
							return this.props.history.push('/confirm-phone');
						}
					}).catch((error) => {
						console.error('Error checking phone verification:', error);
						// On error, assume not verified for security
						localStorage.setItem('backto', 'userarea');
						return this.props.history.push('/confirm-phone');
					});
				}
			})
	}


	componentDidMount() {
		window.addEventListener('message', this.handleAppleResponse);

		//check if user is comming from 3rd party web site
		const query = new URLSearchParams(this.props.location.search);
		const partner = query.get('partner')
		const btq_token = query.get('token')
		const btq_id = query.get('id')
		//console.log('3rdparty_params:',query, partner,  btq_token, btq_id);



		if (btq_token) {
			cookies.set("access_token", btq_token);
			return this.getUserInfo();
		}

		/**
		 * Coupon code on login
		 */
		let url = new URL(document.URL);
		url = url.href.replace('#', '/');
		let coupon = (new URL(url)).searchParams.get('coupon');
		if(coupon) localStorage.setItem('coupon', coupon);

		/**
		 * Coupon renewal code on login
		 */
		let couponrenew = (new URL(url)).searchParams.get('couponrenew');
		if(couponrenew) localStorage.setItem('couponrenew', couponrenew);

		//TODO uncomment the 3lines
		let hasAccessToken = cookies.get('access_token');

		this.setState({hasAccessToken:!!hasAccessToken});

		if (isLogged()) {
			this.gotoUserArea();
		}

		user = JSON.parse(localStorage.getItem('user'));

		this.validateLoginFields();


	}
	componentWillUnmount() {
		window.removeEventListener('message', this.handleAppleResponse);
}

	validateLoginFields() {
		this.setState({
			loginEnable: validateEmail(this.state.email) && (this.state.password.length > 0)
		})
		// this.forceUpdate(() => {
		//   if (validateEmail(this.state.email) && (this.state.password.length > 0)) this.nameInput.focus();
		// })
	}


	// user login action
	// @params : username (mail) and password
	// @return : login object   
	userLogin(e) {
		e.preventDefault();
		this.setState({
			loginEnable: false,
			warning: false,
			warningMessage: ""
		})
		try {

			// login
			userLoginFetch(this,
				{
					email: this.state.email,
					password: this.state.password,
					app: "web",
					platform: Config.platform,
					version: Config.version
				}
			)
				.then((response) => {
					console.log("userLoginFetch: response: ", response)

					// null
					if (response == null) {
						return;
					}

					// fail
					if (response.status == "fail") {

					// console.log("userLoginFetch: !!FAIL!!: ", response.message)

						this.setState({
							warningMessage: tr.t("NovalidEmailPass"),
							usrnameErr: true,
							passErr: true,
							warning: true,
							email: "",
							password: "",
						});
					}

					// else if (response.status == "user_not_confirmed_sms") {
					// }

					else {

						cookies.set("access_token", response.access_token);

					// console.log("userLoginFetch: !!Success!!: ", response);

						this.getUserInfo();
					}
				});
		}
		catch (e) {
		// console.log(e);
		}
	}

	getUserInfo = () =>{
		let access_token =  cookies.get('access_token')
		try {
			// fill storage w/ user data.
			//console.log("userLoginFetch: !!Success!!:access_token  ", access_token);
			userFetch(this, { access_token: access_token }
			).then((response) => {
				//console.log("userLoginFetch: !!Success!!:", response);
				if (!response) {
					localStorage.clear();
					cookies.remove('access_token');
					return this.setState({
						warning: true,
						warningMessage: "Errore di sistema!"
					})
				}
				localStorage.setItem('user', JSON.stringify(response));

				// Track login success
				FirebaseLogger.getInstance().regEvent("LOGIN", {
					user_id: response.user_id,
					email: response.email,
					method: "email"
				}, "SUCCESS");

				// Check phone verification status before redirecting
				isPhoneNumberVerified(this).then((phoneResponse) => {
					if (phoneResponse && phoneResponse.status === 'success') {
						if (phoneResponse.verified === 0) {
							// Phone not verified, redirect to verification page
							localStorage.setItem('backto', 'userarea');
							return this.props.history.push('/confirm-phone');
						}
						// Phone verified, proceed to user area
						this.gotoUserArea();
					} else {
						// If check fails, assume not verified for security
						localStorage.setItem('backto', 'userarea');
						return this.props.history.push('/confirm-phone');
					}
				}).catch((error) => {
					console.error('Error checking phone verification:', error);
					// On error, assume not verified for security
					localStorage.setItem('backto', 'userarea');
					return this.props.history.push('/confirm-phone');
				});
			});
		} catch (e) {
			//console.log(e);
		}
	}
	

	//FB Login
	DEPRECATED_responseFacebook = (result) => {

		let access_token = cookies.get('access_token');
		if (!!access_token) return; //to prevent double login
		//console.log("resultFacebook", result, access_token);
		if (!result) return
		userLoginFetch(this, {
			email: result.email,
			name: result.first_name,
			surname: result.last_name,
			app: "web",
			id_facebook: result.id,
			loginWithFacebook: true,
			remember_token: 1
		}).then((response) => {
			//console.log("userLoginFetch", response);

			if (response.status == "fail") {
			// console.log("userLoginFetch ", result);
				//handle fail cases
				let fb_info = { id_facebook: result.id, name: result.first_name, email: result.email, surname: result.last_name, photo: result.picture.data.url, accessToken: result.accessToken };
				localStorage.setItem('fb_user', JSON.stringify(fb_info));
				return this.props.history.push('/signup');
			} else {
				//success cases
				cookies.set("access_token", response.access_token);

				//console.log("userLoginFetch: !!Success!!: ", response);

				try {
					// fill storage w/ user data.
					//console.log("userLoginFetch: !!Success!!:response.access_token  ", response.access_token);
					userFetch(this, { access_token: response.access_token }
					).then((response) => {
					// console.log("userLoginFetch: !!Success!!:", response);
						if (!response) {
							localStorage.clear();
							cookies.remove('access_token');
							return this.setState({
								warning: true,
								warningMessage: "Errore di sistema!"
							})
						}
						localStorage.setItem('user', JSON.stringify(response));
						this.gotoUserArea();
					});
				} catch (e) {
				// console.log(e);
				}
			}

		});

		/////////
	}   


	responseFacebook = (result) => {
		let access_token = cookies.get('access_token');
		if (!!access_token) return; //to prevent double login
		//console.log("resultFacebook", result, access_token);
		if (!result) return
		let params = {};
		params.social_provider = "facebook";
		params.social_id = result.id;
		params.email = result.email;
		params.name = result.first_name;
		params.surname = result.last_name;
		params.photo = result.picture.data.url;
		this.socialLogin(params);
	}

	async googleLogin(e) {
		e.preventDefault();
		//console.log("google: ");
		var provider = new firebase.auth.GoogleAuthProvider();
		provider.setCustomParameters({
			'login_hint': 'user@example.com'
		});
		//console.log("google: ", provider);

		try {
			let result = await firebase.auth().signInWithPopup(provider);
		// console.log("google: ", result);
			// This gives you a Google Access Token. You can use it to access the Google API.
			var token = result.credential.accessToken;
			// The signed-in user info.
			var user = result.additionalUserInfo.profile;
			//console.log("onGoogleButtonPress @user", user);
			const { email, family_name, given_name, id, picture, } = user;

			let params = {};
			params.social_provider = "google";
			params.social_id = id;
			params.email = email;
			params.name = given_name;
			params.surname = family_name;
			params.photo = picture;
		// console.log("onGoogleButtonPress @params", params);
			this.socialLogin(params);
		} catch (error) {
			this.setState({
				warning: true,
				warningMessage: tr.t("Oops"),
			})
			return;
		}
	}


	handleAppleResponse = (e) => {
    if(Config.test == "0") {
      return;
    }
    
		if (e.data) {
			let data = JSON.parse(e.data);
		// console.log("iframe: @data", data);
			if (data.status === "success") {
				let appleResponse = data.response;
			// console.log(appleResponse);
				fetch(`https://awsservices.mypass.technology/prod/v1/verifyappleuser?userToken=${appleResponse.authorization.id_token}`)
					.then(response => response.json())
					.then(data => {
						//console.log(data)
						if (data.status === "success") {
							let params = {};
							params.social_provider = "apple";
							params.social_id = data.clientId;
							if (appleResponse.user) {
								params.email = appleResponse.user.email;
								params.name = appleResponse.user.name.firstName;
								params.surname = appleResponse.user.name.lastName;
							};
						// console.log(params);
							this.socialLogin(params);
						} else {
							//TODO: Handle errors
						}
					});
			} else return;
		}
	}

	socialLogin(params) {
		//console.log("socialLogin @params", params);
		let _params = {};
		_params.social_provider = params.social_provider;
		_params.social_id = params.social_id;
		if (params.name) _params.name = params.name;
		if (params.surname) _params.surname = params.surname;
		if (params.email) _params.email = params.email;
		if (params.photo) _params.photo = params.photo;

		//console.log("socialLogin @_params", _params);
		userRegForSocialLogin(this, _params).then(response => {
			this.setState({ active: false })
			//console.log("socialLogin @response", response);
			// undefined
			if (typeof response === 'undefined') {
				this.setState({
					warning: true,
					warningMessage: tr.t("Oops"),
				})
				return;
			}
			if (response && response.status === "fail") {
				return this.setState({
					warning: true,
					warningMessage: response.message,
				})
			}

			try {

				FirebaseLogger.getInstance().regEvent("Registeration_" + params.social_provider,
        {
          social: _params.social_provider,
          social_id: _params.social_id,
          name: _params.name,
          surname: _params.surname,
          email: _params.email
        }
        , "NEW");

				// fill storage w/ user data.
				//console.log("userLoginFetch: !!Success!!:response.access_token  ", response.access_token);
				userFetch(this, { access_token: response.access_token }
				).then((userResponse) => {
					//console.log("userLoginFetch: !!Success!!:", userResponse);
					if (!userResponse) {
						localStorage.clear();
						cookies.remove('access_token');
						return this.setState({
							warning: true,
							warningMessage: "Errore di sistema!"
						})
					}
					localStorage.setItem('user', JSON.stringify(userResponse));
					cookies.set("access_token", response.access_token);
					
					// Check phone verification status before redirecting
					isPhoneNumberVerified(this).then((phoneResponse) => {
						if (phoneResponse && phoneResponse.status === 'success') {
							if (phoneResponse.verified === 0) {
								// Phone not verified, redirect to verification page
								localStorage.setItem('backto', 'userarea');
								return this.props.history.push('/confirm-phone');
							}
							// Phone verified, proceed to user area
							this.gotoUserArea();
						} else {
							// If check fails, assume not verified for security
							localStorage.setItem('backto', 'userarea');
							return this.props.history.push('/confirm-phone');
						}
					}).catch((error) => {
						console.error('Error checking phone verification:', error);
						// On error, assume not verified for security
						localStorage.setItem('backto', 'userarea');
						return this.props.history.push('/confirm-phone');
					});
				});
			} catch (e) {
				//console.log(e);
			}
		
		});
	
	}


	// HANDLERS

	handleChangeUsername = (e) => {
		// console.log("e XXX", e)
		this.setState({
			warningMessage: tr.t("NovalidEmailPass"),
			usrnameErr: false,
			passErr: false,
			warning: false,
		})
		this.setState({ email: e.target.value }, () => {
			this.validateLoginFields();
		});
	}

	handleChangePassword = (e) => {
		this.setState({
			warningMessage: tr.t("NovalidEmailPass"),
			usrnameErr: false,
			passErr: false,
			warning: false,
		})
		this.setState({ password: e.target.value }, () => {
			this.validateLoginFields();
		});
	}

	eChange = () => {
		//console.log("this.state.passFlag", this.state.passFlag)
		if (this.state.passFlag == "password") {
			this.setState({ passFlag: "text" })
		}
		else {
			this.setState({ passFlag: "password" })
		}
	}

	gotoNextPage = () => {
		this.setState({ redirect: true });
		return <Redirect to='/confirm' />
	}

	gotoRegistration = () => {
		this.setState({ redirect: true });
	}

	alertResponse(info) {
		switch (info.type) {
			case "closeButton":
				this.setState({ warning: false })
				break;
			case "actionButton":
				if (info.option1 == "attention") {
					this.setState({ warning: false })
					break;
				}
		}
	}

	// async testGA(e) {
	//   e.preventDefault();
		
		
		
	//   setInterval(() => {
	//     console.log("testGA");
	//     // firebase.analytics().logEvent('TEST_' + "WEB", { value: 10, amount: 10, currency: "EUR", os: isBrowser ? "web" : isAndroid ? "android" : "ios" });
	//     FirebaseLogger.getInstance().regEvent("Purchase", 10);
	//   }, 1000);
	// }

	render() { 
		return (
			<div>
				{!this.state.redirect &&
				<div>
					<BrowserView>
						<div className="sn_overlay d-lg-none"></div>
						<div className="sn_login">
							<div className="sn_login__return">
								<a href="https://mypass.ski/">{tr.t("Returnsite")}</a>
							</div>
							<div className="container">
								<div className="row">
									<div className="col-12 col-lg-9 mx-auto">
										<div className="sn_login__container p-3 p-md-4 p-lg-5">
											<div className="sn_login__container__logo">
												<img src={ stck } alt=""/>
											</div>
											<div className="sn_login__container__title">
												<img src={ logo } alt=""/>
											</div>
											<h3 className="text-center">{ tr.t("Wespeed") }</h3>
											<div className="sn_login__container__inputs mb-5">
												<div className="sn_login__container__input">
													<img src={mail} />
													<input type="email" name="email" spellCheck="false" placeholder="user@mail.com" className={(this.state.usrnameErr) ? "err_red" : "err_no"} maxLength="50" value={this.state.email} onChange={this.handleChangeUsername} />
												</div>
												<div className="sn_login__container__input mb-2">
													<img src={lock} />
													<input type={(this.state.passFlag == "password") ? "password" : "text"} name="name" spellCheck="false" placeholder="password" className={(this.state.passErr) ? "err_red sn_psw" : "err_no sn_psw"} maxLength="50" value={this.state.password} minLength="8" onChange={this.handleChangePassword} />
													<span>
														<label className={isFirefox ? "eSwitchlf" : "eSwitchl"}>
															<input type="checkbox" onChange={this.eChange} />
															<span className="sliderl round"></span>
														</label>
													</span>
												</div>              
												<a onClick={() => { return this.props.history.push('/resend-password') }}>
													<p>
														{ tr.t("Youforget") }
													</p>
												</a>
											</div>
											<div className="sn_login__container__wrapbuttons">
												<div> 
													<button ref={(input) => { this.nameInput = input; }} disabled={!this.state.loginEnable} className="lbtn sn_btn mb-2" onClick={this.userLogin}>{tr.t("Login")}</button>
												</div> 
												<FacebookLogin
													appId="1348559705282609"
													autoLoad={false}
													fields="first_name, last_name ,email, picture"
													callback={(resp)=>this.responseFacebook(resp)}
													cssClass="fbtn mb-2"
													// icon="fa-facebook"
												/>
												<div>
													<button className="googleBtn mb-2" onClick={this.googleLogin}>{tr.t("loginbyGoogle")}</button>
												</div>  
												{Config.test == "0" &&
													<form>
														<iframe
															ref={(f) => this.ifr = f}
															sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
															style={{ width: '107%', border: 0, height: 60, marginLeft: -10, marginTop: -8 }}
															src={"https://user.mypass.ski/apple.html"}
															onError={(e) => console.warn('Apple iframe failed to load:', e)}
														/>
													</form>}         
											</div>                 
											<p className="mt-3">
												{tr.t("Nothave")} <b><Link to="/signup" onClick={this.gotoRegistration}>{tr.t("Signup")}</Link></b>
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</BrowserView>

					<MobileView>
					<div className="sn_overlay d-lg-none"></div>
						<div className="sn_login">
							<div className="sn_login__return">
								<a href="https://mypass.ski/">{tr.t("Returnsite")}</a>
							</div>
							<div className="container">
								<div className="row">
									<div className="col-12 col-lg-9 mx-auto">
										<div className="sn_login__container p-3 p-md-4 p-lg-5">
											<div className="sn_login__container__logo">
												<img src={ stck } alt=""/>
											</div>
											<div className="sn_login__container__title">
												<img src={ logo } alt=""/>
											</div>
											<h3 className="text-center">{ tr.t("Wespeed") }</h3>
											<div className="sn_login__container__inputs mb-5">
												<div className="sn_login__container__input">
													<img src={mail} />
													<input type="email" name="email" spellCheck="false" placeholder="user@mail.com" className={(this.state.usrnameErr) ? "err_red" : "err_no"} maxLength="50" value={this.state.email} onChange={this.handleChangeUsername} />
												</div>
												<div className="sn_login__container__input mb-2">
													<img src={lock} />
													<input type={(this.state.passFlag == "password") ? "password" : "text"} name="name" spellCheck="false" placeholder="password" className={(this.state.passErr) ? "err_red sn_psw" : "err_no sn_psw"} maxLength="50" value={this.state.password} minLength="8" onChange={this.handleChangePassword} />
													<span>
														<label className={isFirefox ? "eSwitchlf" : "eSwitchl"}>
															<input type="checkbox" onChange={this.eChange} />
															<span className="sliderl round"></span>
														</label>
													</span>
												</div>              
												<a onClick={() => { return this.props.history.push('/resend-password') }}>
													<p>
														{ tr.t("Youforget") }
													</p>
												</a>
											</div>
											<div className="sn_login__container__wrapbuttons">
												<div> 
													<button ref={(input) => { this.nameInput = input; }} disabled={!this.state.loginEnable} className="lbtn sn_btn mb-2" onClick={this.userLogin}>{tr.t("Login")}</button>
												</div> 
												<FacebookLogin
													appId="1348559705282609"
													autoLoad={false}
													fields="first_name, last_name ,email, picture"
													callback={(resp)=>this.responseFacebook(resp)}
													cssClass="fbtn mb-2"
													// icon="fa-facebook"
												/>
												<div>
													<button className="googleBtn mb-2" onClick={this.googleLogin}>{tr.t("loginbyGoogle")}</button>
												</div>  
												{Config.test == "0" &&
													<form>
														<iframe
															ref={(f) => this.ifr = f}
															sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
															style={{ width: '107%', border: 0, height: 60, marginLeft: -10, marginTop: -8 }}
															src={"https://user.mypass.ski/apple.html"}
															onError={(e) => console.warn('Apple iframe failed to load:', e)}
														/>
													</form>}         
											</div>                 
											<p className="mt-3">
												{tr.t("Nothave")} <b><Link to="/signup" onClick={this.gotoRegistration}>{tr.t("Signup")}</Link></b>
											</p>
											<div className="mt-4 text-center">
												<DownloadAppButton source_page="login" />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</MobileView>

					{
						this.state.warning ?
							<div className="containerModal">
							{
								this.state.warning ?
								<AlertPnl textbar1={tr.t("Attention")} secondbar={true} textbar2={this.state.warningMessage} singlebtn={true} textbtn1={tr.t("Ok")} sizebtn={"small"} option1={"attention"} callback={this.alertResponse.bind(this)} /> : null
							}
							</div> : null 
					}
				</div>
				}
			</div>
		);
	}
}

export default Login;

//validating the email
function validateEmail(email) {
	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(String(email).toLowerCase());
}



// WEBPACK FOOTER //
// ./src/screens/Login/Login.js